function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "walk");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "iPhone-XS-Copy-3",
  transform: "translate(-85.000000, -141.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "ic_directions_walk_24px",
  transform: "translate(79.500000, 140.500000)"
}, React.createElement("path", {
  d: "M12.9375,5.27083333 C13.9916667,5.27083333 14.8541667,4.40833333 14.8541667,3.35416667 C14.8541667,2.3 13.9916667,1.4375 12.9375,1.4375 C11.8833333,1.4375 11.0208333,2.3 11.0208333,3.35416667 C11.0208333,4.40833333 11.8833333,5.27083333 12.9375,5.27083333 Z M6.70833333,22.0416667 L8.72083333,22.0416667 L10.4458333,14.375 L12.4583333,16.2916667 L12.4583333,22.0416667 L14.375,22.0416667 L14.375,14.8541667 L12.3625,12.9375 L12.9375,10.0625 C14.1833333,11.5 16.1,12.4583333 18.2083333,12.4583333 L18.2083333,10.5416667 C16.3875,10.5416667 14.8541667,9.58333333 14.0875,8.24166667 L13.1291667,6.70833333 C12.7458333,6.13333333 12.1708333,5.75 11.5,5.75 C11.2125,5.75 11.0208333,5.84583333 10.7333333,5.84583333 L5.75,7.95416667 L5.75,12.4583333 L7.66666667,12.4583333 L7.66666667,9.2 L9.39166667,8.52916667 L6.70833333,22.0416667 Z",
  id: "walk"
}))));

var SvgWalk = function SvgWalk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "13px",
    height: "22px",
    viewBox: "0 0 13 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWalk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/walk.f76286b3.svg";
export { ForwardRef as ReactComponent };